import {WeaTools, WeaLocaleProvider} from 'ecCom';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import forEach from 'lodash/forEach';
import isString from 'lodash/isString';
import { toJS } from 'mobx';
const getLabel = WeaLocaleProvider.getLabel;

function empty(data) {
  const d = toJS(data);
  if (isString(d)) {
    return !d;
  }

  if (isArray(d)) {
    return isEmpty(d) || isEmpty(d[0]);
  }

  return isEmpty(d);
}

function getRules() {return {
  stringLength: {
    fn: (val, req) => WeaTools.getStringLength(val) <= req,
    message: getLabel('386981', ':attribute 长度不能超过 :stringLength 个字符'),
  },
  reqWhen: {
    fn(val, req) {
      val = toJS(val);
      if (req) {
        const rules = {};
        req.split('&').forEach((s)=> {
          rules[s.split(':')[0]] = s.split(':')[1];
        })
        const params = this.getFormDatas();
        let validate = true;
        forEach(rules, (value, key)=> {
          if (params[key] && params[key].value) {
            if (Array.isArray(params[key].value) && isEmpty(params[key].value)) {
              validate = false;
            }
            if (value !== params[key].value.toString()) {
              validate = false;
            };
          } else {
            validate = false;
          }
        })
        if (validate) {
          if (val == '' || val== undefined) return false;
        }
      }
      return true;
    },
    message: getLabel('386982', ':attribute 未填写完整'),
  },
  scopeRequired: {
    fn(val, req) {
      val = toJS(val);
      if (isEmpty(val)) {
        return false;
      }
      if (isArray(val)) {
        if (val[0] === undefined || val[0] === '') {
          return false;
        }
        if (val[1] === undefined || val[1] === '') {
          return false;
        }
      }
      return true;
    },
    message: getLabel('386982', ':attribute 未填写完整'),
  },
  scopeDirty: {
    fn(val, req) {
      val = toJS(val);
      if (isArray(val)) {
        if (isEmpty(val[0]) && isEmpty(val[1])) {
          return val[0] <= val[1];
        }
      }
      return true;
    },
    message: getLabel('386983', ':attribute 左边的值应该小于右边的值'),
  },
  selectLinkageRequired: {
    fn(val, req, key) {
      val = toJS(val);
      const filed = this.fieldMap[key] || {};
      if (isEmpty(val)) {
        return false;
      }
      if (isArray(val)) {
        if (isEmpty(val[0])) {
          return false;
        }

        if (!isEmpty(val[0]) && empty(val[1])) {
          if (filed.selectLinkageDatas) {
            if (filed.selectLinkageDatas[val[0]] && (filed.viewAttr == 3 || filed.selectLinkageDatas[val[0]].viewAttr == 3)) return false;
          } else {
            return false;
          }
        }
      }
      return true;
    },
    message: getLabel('386982', ':attribute 未填写完整'),
  },
  databaseColumn: {
    fn: (valuechar, req) => {
      if(valuechar.length==0){
        return true;
      }
      let notcharnum = false ,notchar = false ,notnum = false ;
      for(let i=0 ; i<valuechar.length ; i++) {
        notchar = false ;
        notnum = false ;
        let charnumber = parseInt(valuechar[i]) ; if(isNaN(charnumber)) notnum = true ;
        // if(valuechar[i].toLowerCase()<'a' || valuechar[i].toLowerCase()>'z')
        // notchar = true ;
        if((valuechar[i].toLowerCase()<'a' || valuechar[i].toLowerCase()>'z')&&valuechar[i]!='_') notchar = true ;
        if(notnum && notchar) notcharnum = true ;
      }
      if(valuechar[0].toLowerCase()<'a' || valuechar[0].toLowerCase()>'z') notcharnum = true ;
      if(notcharnum) return false ;
      return true;
    },
    message: getLabel('386984', ':attribute 不符合要求'),
  },
   alpha_num_underline: {
     fn(val){
       return (/^[a-zA-Z0-9_]+$/).test(val);
     },
     message: getLabel('386985', ':attribute 只能包含字母,数字和下划线'),
   },
}}

export default getRules;


// WEBPACK FOOTER //
// ./comMobx/wea-form/rules.js